<template>
  <v-container>

    <div v-if="!user" class="mt-10">
      <h4 class="font-weight-bold title-page primary--text mb-8" tabindex="0">Editar Credor</h4>
      <h4>Por favor, realize o seu login para ter acesso aos dados dos credores associados.</h4>
    </div>

    <div v-if="user">
      <v-row>
        <v-col :cols="12">
          <div class="title-container">
            <div class="font-weight-bold mt-10 title-page">Editar</div>
            <div class="button-group">
              <v-btn type="button" elevation="0" color="primary" @click="updateUser" :disabled="dataset.loading"
                :loading="saving">
                Atualizar
              </v-btn>
              <v-btn id="btnBack" type="button" elevation="0" color="primary" outlined
                to="/credores-procurador">Voltar</v-btn>
            </div>
          </div>
        </v-col>
      </v-row>

      <div class="mt-4" v-if="dataset.loading">
        <v-progress-circular indeterminate color="primary" size="50"></v-progress-circular>
      </div>

      <v-form ref="form" v-model="validForm">
        <v-row>
          <v-col cols="12">
            <v-card class="card-form-outlined">
              <v-card-title class="card-group-title">Dados credor</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="6">
                    <v-text-field dense id="name" label="Nome completo" v-model="dataset.data.name" required
                      :rules="[$rules.required]" outlined hide-details="auto">
                    </v-text-field>
                  </v-col>
                  <v-col cols="12" sm="6">
                    <v-text-field dense id="Email" label="Email" :value="dataset.data.email" :disabled="true"
                      :rules="rulesIfEnabled(false, [$rules.required])" outlined hide-details="auto">
                    </v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="6">
                    <v-select dense id="nationality" label="Nacionalidade" :items="dataset.countryList"
                      item-text="nome_pais" item-value="sigla" v-model="dataset.data.nationality" required
                      :rules="[$rules.required]" outlined hide-details="auto"></v-select>
                  </v-col>

                  <v-col cols="12" sm="3">
                    <v-text-field dense label="Telefone" v-model="dataset.data.phone_number" required outlined
                      :rules="[$rules.required]" hide-details="auto">
                    </v-text-field>
                  </v-col>

                  <v-col cols="12" sm="3">
                    <v-text-field dense id="registration" label="CPF/CNPJ"
                      :value="formatCpfCnpj(dataset.data.registration)" :disabled="true"
                      :rules="rulesIfEnabled(false, [$rules.required, $rules.cpfCnpj])" outlined hide-details="auto">
                    </v-text-field>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>

          </v-col>
        </v-row>

        <v-row v-if="user">
          <v-col cols="12">
            <v-card class="card-form-outlined">
              <v-card-title class="card-group-title">
                <span class="table-card-title">Documento</span>
              </v-card-title>

              <v-card-text>
                <v-row>

                  <!-- ================= DOCUMENTO PRINCIPAL ================= -->
                  <v-col cols="12" md="4">
                    <v-card outlined>
                      <v-card-title class="subtitle-1 text-uppercase">
                        <span><strong>{{ isRegistrationCNPJ ? 'Contrato Social' : 'Documento de Identificação' }}</strong> </span>
                      </v-card-title>

                      <v-card-text>
                        <v-btn v-if="dataset.data.url_document" small outlined color="primary"
                          :href="dataset.data.url_document" target="_blank">
                          <v-icon left small>mdi-eye</v-icon>
                          Visualizar documento
                        </v-btn>

                        <v-file-input class="mt-3" dense accept="image/png, image/jpeg, application/pdf" prepend-icon=""
                          outlined counter show-size :rules="changeDocumentRules" hint="Máximo 15MB" hide-details="auto"
                          :label="isRegistrationCNPJ ? 'Trocar Contrato Social' : 'Trocar Documento'" :clearable="true"
                          @change="onFileSelected($event)" ref="logoFile" truncate-length="70">
                        </v-file-input>

                        <v-row v-if="dataset.data.url_document" class="mt-n5">
                          <v-col>
                            <iframe :src="dataset.data.url_document" style="max-width: 260px; height: 140px;"
                              frameborder="0" class="rounded-xl mt-2" />

                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-col>

                  <!-- ================= OUTROS DOCUMENTOS ================= -->
                  <v-col cols="12" md="8" v-if="isRegistrationCNPJ">
                    <v-card outlined>
                      <v-card-title class="subtitle-1 text-uppercase">
                        <span><strong>Outros Documentos</strong> </span>
                      </v-card-title>

                      <v-card-text>
                        <v-btn small outlined color="primary" class="mb-3" @click="openOtherDocumentPicker">
                          <v-icon left>mdi-plus</v-icon>
                          Adicionar documento
                        </v-btn>
                        <v-list dense v-if="otherDocuments && otherDocuments.length > 0">
                          <v-list-item v-for="(doc, index) in otherDocuments" :key="doc.id || index">
                            <v-list-item-content>
                              <v-list-item-title class="d-flex align-center">

                                {{ doc.name || `Documento ${index + 1}` }}

                                <v-tooltip bottom>
                                  <template #activator="{ on, attrs }">
                                    <v-chip x-small class="ml-2" :color="doc._isNew ? 'orange' : 'green'"
                                      text-color="white" v-bind="attrs" v-on="on">
                                      {{ doc._isNew ? 'Novo' : 'Salvo' }}
                                    </v-chip>
                                  </template>
                                  <span>
                                    {{ doc._isNew
                                      ? 'Documento novo (ainda não salvo)'
                                      : 'Documento já cadastrado' }}
                                  </span>
                                </v-tooltip>

                              </v-list-item-title>

                              <v-list-item-subtitle v-if="doc.created_at" class="caption grey--text">
                                Criado em: {{ formatDate(doc.created_at) }}
                              </v-list-item-subtitle>
                            </v-list-item-content>

                            <v-list-item-action>
                              <div class="d-flex align-center">
                                <v-tooltip bottom>
                                  <template #activator="{ on, attrs }">
                                    <v-btn icon v-bind="attrs" v-on="on" :href="doc.documentUrl" target="_blank">
                                      <v-icon color="primary">mdi-eye</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Visualizar documento</span>
                                </v-tooltip>
                                <v-tooltip bottom>
                                  <template #activator="{ on, attrs }">
                                    <v-btn icon color="red" v-bind="attrs" v-on="on"
                                      @click="removeOtherDocument(index)">
                                      <v-icon>mdi-delete</v-icon>
                                    </v-btn>
                                  </template>
                                  <span>Remover documento</span>
                                </v-tooltip>
                              </div>
                            </v-list-item-action>
                          </v-list-item>
                        </v-list>

                        <div v-else class="text-center grey--text caption">
                          Nenhum documento adicional cadastrado
                        </div>

                        <v-file-input ref="otherDocInput" v-show="false" accept="image/png, image/jpeg, application/pdf"
                          @change="addOtherDocument" />

                      </v-card-text>
                    </v-card>
                  </v-col>

                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="12">
            <v-card class="card-form-outlined">
              <v-card-title class="card-group-title">Endereço</v-card-title>
              <v-card-text>
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field dense id="address_postal_code" label="CEP" v-model="dataset.data.address_postal_code"
                      required :rules="[$rules.required, $rules.cep]" outlined hide-details="auto" v-mask="'##.###-###'"
                      @blur="fetchCep(dataset.data.address_postal_code, dataset.data)"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-text-field dense id="address_street" label="Rua/Avenida" v-model="dataset.data.address_street"
                      required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>

                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field dense id="address_number" label="Número" v-model="dataset.data.address_number"
                      required :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="8">
                    <v-text-field dense id="address_complement" label="Complemento"
                      v-model="dataset.data.address_complement" outlined hide-details="auto"></v-text-field>
                  </v-col>
                </v-row>
                <v-row>
                  <v-col cols="12" sm="4">
                    <v-text-field dense id="address_neighborhood" label="Bairro"
                      v-model="dataset.data.address_neighborhood" required :rules="[$rules.required]" outlined
                      hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-text-field dense id="address_city" label="Cidade" v-model="dataset.data.address_city" required
                      :rules="[$rules.required]" outlined hide-details="auto"></v-text-field>
                  </v-col>
                  <v-col cols="12" sm="4">
                    <v-autocomplete dense id="address_state" label="Estado" :items="dataset.statesList" item-text="name"
                      item-value="sigla" v-model="dataset.data.address_state" required :rules="[$rules.required]"
                      outlined hide-details="auto"></v-autocomplete>
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>
      </v-form>

      <!-- <v-row v-if="isRegistrationCNPJ">
        <v-col cols="12">
          <v-card class="card-form-outlined" color="gray">
            <v-card-title class="card-group-title">
              <div class="title-container">
                <div class="title-block">
                  <span id="title" class="table-card-title">Outros Documentos</span>
                </div>
              </div>
            </v-card-title>
            <v-card-text>
              <v-row>
                <v-col>
                  <v-btn small outlined color="primary" @click="addOtherFile">
                    <v-icon left>mdi-plus</v-icon>
                    Adicionar documento
                  </v-btn>
                </v-col>
              </v-row>
              <v-row>
                <v-col v-for="(doc, index) in dataset.data.company_other_files" :key="index" cols="12" sm="3">
                  <v-row>
                    <v-col>
                      <span><strong>Documento - {{ index + 1 }}</strong></span>
                    </v-col>
                  </v-row>

                  <v-card-text v-if="!doc || !doc.id">
                    <v-row>
                      <v-col>
                        <v-file-input dense outlined hide-details label="Estatuto, ata, etc..."
                          accept="image/png, image/jpeg, application/pdf"
                          @change="file => onCompanyOtherFiles(file, index)" />
                      </v-col>
                    </v-row>
                  </v-card-text>
                  <v-card-text v-else>
                    <v-row>
                      <v-col cols="12">
                        <v-btn small outlined color="primary" :href="doc.url" target="_blank">
                          Visualizar documento
                        </v-btn>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col cols="12">
                        <v-file-input dense outlined hide-details label="Trocar documento"
                          accept="image/png, image/jpeg, application/pdf"
                          @change="file => onCompanyOtherFiles(file, index)" />
                      </v-col>
                    </v-row>

                   
                    <v-row class="mt-n3">
                      <v-col>
                        <iframe :src="doc.url" width="250" height="150" frameborder="0" class="rounded-xl"></iframe>
                      </v-col>
                    </v-row>

              
                    <v-row>
                      <v-col>
                        <v-btn small text color="red" @click="removeOtherFile(index)">
                          Remover
                        </v-btn>
                      </v-col>
                    </v-row>

                  </v-card-text>
                </v-col>

              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row> -->

      <v-row v-if="isRegistrationCNPJ">
        <v-col cols="12" class="d-flex justify-space-between align-center card-group-title">
          Representante{{ activeRepresentatives.length > 1 ? 's' : '' }}({{ activeRepresentatives.length }})
          <v-btn color="primary" type="button" elevation="0" class='mr-5' small @click="openRepresentativesModal">
            <v-icon left small>mdi-pencil</v-icon>
            Gerenciar
          </v-btn>
        </v-col>
      </v-row>

      <v-row v-if="isRegistrationCNPJ">
        <v-col cols="12" v-for="(rep, index) in activeRepresentatives" :key="rep.id" class="mb-n3">
          <v-card outlined>
            <v-card-title class="subtitle-2">
              Representante #{{ index + 1 }}
            </v-card-title>
            <v-card-text>
              <div><strong>Nome:</strong> {{ rep.name }}</div>
              <div><strong>E-mail:</strong> {{ rep.email }}</div>
              <div><strong>CPF:</strong> {{ formatCpfCnpj(rep.registration) }}</div>
              <div class="mt-3">
                <v-btn v-if="rep.documentUrl" small outlined color="primary" :href="rep.documentUrl" target="_blank">
                  <v-icon left small>mdi-eye</v-icon>
                  Visualizar documento
                </v-btn>
                <span v-else class="grey--text">Documento pendente</span>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>

      <v-dialog v-model="representativesModal" max-width="900" persistent>
        <v-card>
          <v-card-title class="font-weight-bold primary--text justify-center">
            Gerenciar representante(s)
          </v-card-title>
          <v-card-text>

            <v-divider></v-divider>

            <br>
            <div v-for="(rep, index) in modalRepresentatives" :key="index" class="mb-2 pb-6 border-b">
              <div class="d-flex justify-space-between align-center mb-4">
                <h3>Representante # {{ index + 1 }}</h3>
                <v-btn icon color="error" @click="removeRep(index)" :disabled="modalRepresentatives.length === 1"
                  title="Remover representante">
                  <v-icon>mdi-delete</v-icon>
                </v-btn>
              </div>

              <v-row>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="rep.name" label="Nome" :rules="[$rules.required]" outlined dense
                    hide-details="auto" />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="rep.email" label="E-mail" :rules="[$rules.required, $rules.email]" outlined
                    hide-details="auto" dense />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-text-field v-model="rep.registration" label="CPF" v-mask="'###.###.###-##'" hide-details="auto"
                    :rules="[$rules.required]" outlined dense />
                </v-col>
                <v-col cols="12" sm="6">
                  <v-file-input v-model="rep.file" label="Documento de identificação" accept="application/pdf,image/*"
                    outlined dense show-size prepend-icon="" :rules="fileRules" clearable hide-details="auto" />
                </v-col>
              </v-row>
              <v-btn v-if="rep.documentUrl" small text color="primary" :href="rep.documentUrl" target="_blank"
                class="mt-2">
                <v-icon left small>mdi-eye</v-icon>
                Documento atual
              </v-btn>
            </div>

            <v-btn color="success" small outlined @click="addRep">
              <v-icon left small>mdi-plus</v-icon>
              Adicionar representante
            </v-btn>
          </v-card-text>

          <v-card-actions>
            <v-spacer />
            <v-btn text @click="closeModal">Cancelar</v-btn>
            <v-btn color="primary" :loading="saving" @click="saveRepresentatives">
              Salvar
            </v-btn>
            <br>
            <br>
          </v-card-actions>
        </v-card>
      </v-dialog>
    </div>
  </v-container>
</template>
<script>
import axios from "axios";
import string from "@/common/util/string";
import statesList from "@/common/data/states-list.data";
import countryList from '@/common/data/country-list.data'
import { cpf, cnpj } from 'cpf-cnpj-validator'

export default {
  name: 'lawyerUserEdit',
  data: () => ({
    validForm: false,
    user: null,
    representativesModal: false,
    modalRepresentatives: [],
    isRegistrationCNPJ: false,
    saving: false,
    loading: false,
    otherDocuments: [],
    changeDocumentRules: [
      v => !v || v.size <= 15000000 || 'Máximo 15MB',
      v => !v || ['image/png', 'image/jpeg', 'application/pdf'].includes(v.type) || 'Formato inválido'
    ],
    dataset: {

      data: {
        representatives: [],
        name: null,
        phone_number: null,
        registration: null,

        address_street: '',
        address_number: '',
        address_complement: '',
        address_neighborhood: '',
        address_city: '',
        address_postal_code: '',
        address_state: null,
        nationality: null,
        representative_name: null,
        representative_registration: null,
        company_other_files: []
      },
      statesList: statesList,
      countryList: countryList,

    },

  }),

  watch: {
    '$route.params.id'(id) {
      console.log('watch executado:', id);

      const creditorId = Number(id);
      this.loadCreditorData(creditorId);
    }
  },

  created() {

    if (this.$root.user) {
      this.user = this.$root.user;
    }

    const creditorId = Number(this.$route.params.id);
    if (creditorId) {
      this.loadCreditorData(creditorId);
    }

  },

  computed: {
    fileRules() {
      const rules = []
      if (!this.dataset.data.documentUrl) {
        rules.push(this.$rules.required)
      }
      rules.push(this.$rules.fileSize(150))
      return rules
    },

    activeRepresentatives() {
      if (!this.dataset.data.representatives) return [];
      return this.dataset.data.representatives.filter(rep => !rep._deleted);
    },

    isOnlyRepresentative() {
      return this.activeRepresentatives.length === 1
    },

  },

  methods: {

    formatCpfCnpj(value) {

      if (!value) {
        return ''
      }

      return value.length == 14 ? cnpj.format(value) : cpf.format(value);
    },

    formatDate(date) {
      if (!date) {
        return '-';
      }

      return new Date(date).toLocaleDateString('pt-BR');
    },

    addOtherDocument(file) {
      if (!file) return

      if (!Array.isArray(this.otherDocuments)) {
        this.otherDocuments = []
      }

      if (
        !this.dataset ||
        !this.dataset.data ||
        !Array.isArray(this.dataset.data.company_other_files)
      ) {
        this.$set(this.dataset.data, 'company_other_files', [])
      }

      this.otherDocuments.push({
        id: null,
        name: file.name,
        documentUrl: URL.createObjectURL(file),
        created_at: new Date(),
        _isNew: true
      })

      this.dataset.data.company_other_files.push(file)

      this.$refs.otherDocInput.reset()
    },

    openOtherDocumentPicker() {
      this.$refs.otherDocInput.$el.querySelector('input').click()
    },

    removeOtherDocument(index) {
      const doc = this.otherDocuments[index]

      if (doc._isNew) {
        this.dataset.data.company_other_files.splice(index, 1)
      }

      if (doc.id) {
        if (!this.dataset.data.deleted_other_documents) {
          this.dataset.data.deleted_other_documents = []
        }
        this.dataset.data.deleted_other_documents.push(doc.id)
      }

      this.otherDocuments.splice(index, 1)
    },

    addNewOtherFile(file) {
      if (!file) return

      this.dataset.data.company_other_files.push(file)

      this.otherDocuments.push({
        id: null,
        name: file.name,
        file,
        documentUrl: null,
        created_at: new Date()
      })
    },

    openOtherFileInput(index) {
      const input = this.$refs.otherFileInputs[index]
      if (input && input.$el) {
        input.$el.querySelector('input').click()
      }
    },

    onFileSelected(file) {
      this.dataset.data.file = file
    },

    // onCompanyOtherFiles(file, index) {
    //   this.dataset.data.company_other_files[index] = file;
    // },

    rulesIfEnabled(isEnabled, rules = []) {
      return isEnabled ? rules : [];
    },

    removeRep(index) {
      if (this.modalRepresentatives.length > 1) {
        this.modalRepresentatives.splice(index, 1);
      }
    },

    closeModal() {
      this.representativesModal = false;
    },

    addRep() {
      this.modalRepresentatives.push({
        id: null,
        name: '',
        email: '',
        registration: '',
        file: null
      });
    },

    openRepresentativesModal() {

      this.modalRepresentatives = this.dataset.data.representatives.map(rep => ({
        id: rep.id || null,
        name: rep.name || '',
        email: rep.email || '',
        registration: rep.registration || '',
        documentUrl: rep.documentUrl || null,
        file: null
      }));
      this.representativesModal = true;
    },

    async saveRepresentatives() {

      for (let i = 0; i < this.modalRepresentatives.length; i++) {
        const rep = this.modalRepresentatives[i];
        const isNew = !rep.id;

        if (!rep.name || rep.name.trim() === '') {
          this.$dialog.notify.error(`Nome do representante ${i + 1} é obrigatório`);
          this.saving = false;
          return;
        }

        if (!rep.email || rep.email.trim() === '') {
          this.$dialog.notify.error(`E-mail do representante ${i + 1} é obrigatório`);
          this.saving = false;
          return;
        }

        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

        if (!emailRegex.test(rep.email.trim())) {
          this.$dialog.notify.error(`E-mail do representante ${i + 1} é inválido`);
          this.saving = false;
          return;
        }

        if (!rep.registration || rep.registration.replace(/\D/g, '').length !== 11) {
          this.$dialog.notify.error(`CPF do representante ${i + 1} é obrigatório e deve ter 11 dígitos`);
          this.saving = false;
          return;
        }

        if (isNew && (!rep.file || !(rep.file instanceof File))) {
          this.$dialog.notify.error(`Documento de identificação é obrigatório para o novo representante ${i + 1}`);
          this.saving = false;
          return;
        }
      }

      this.saving = true;

      try {
        const formData = new FormData();

        const fileIndices = [];

        this.modalRepresentatives.forEach((rep, index) => {
          formData.append(`representatives[${index}][id]`, rep.id || '');
          formData.append(`representatives[${index}][name]`, rep.name);
          formData.append(`representatives[${index}][email]`, rep.email);
          formData.append(`representatives[${index}][registration]`, rep.registration.replace(/\D/g, ''));

          if (rep.file instanceof File) {
            formData.append('representatives_files[]', rep.file);
            fileIndices.push(index);
          }
        });

        formData.append('user_id', this.dataset.data.id);

        fileIndices.forEach(idx => {
          formData.append('representatives_index[]', idx);
        });

        await axios.post('/api/lawyers/user-representatives', formData, {
          headers: { 'Content-Type': 'multipart/form-data' }
        });

        this.$dialog.notify.success('Representante(s) atualizado(s) com sucesso!');

      } catch (error) {
        let apiMessage = 'Erro ao atualizar dados do(s) representante(s)!'

        if (
          error &&
          error.response &&
          error.response.data &&
          error.response.data.content &&
          error.response.data.content.error &&
          error.response.data.content.error.message
        ) {
          apiMessage = error.response.data.content.error.message
        } else if (error && error.response && error.response.data && error.response.data.message) {
          apiMessage = error.response.data.message
        } else if (error && error.message) {
          apiMessage = error.message
        }

        this.$dialog.notify.error(apiMessage, {
          position: 'top-right',
          timeout: 4000
        })

      } finally {
        this.saving = false;
        this.representativesModal = false;
        await this.loadCreditorData(this.dataset.data.id)
      }
    },

    async updateUser() {
      if (!this.$refs.form.validate()) return

      const confirm = await this.$dialog.confirm({
        text: 'Deseja salvar as alterações?',
        title: 'Atualizar Informações',
        actions: {
          false: 'Cancelar',
          true: 'Salvar'
        }
      })

      if (!confirm) return

      this.dataset.loading = true

      const payload = this.buildPayload()

      try {
        await axios.patch('/api/lawyers/user-update', payload, {
          headers: { 'Content-Type': 'multipart/form-data' }
        })

        this.$dialog.notify.success('Dados atualizados com sucesso!', {
          position: 'top-right',
          timeout: 3000
        })

      } catch (error) {

        this.$dialog.notify.error('Erro ao atualizar os dados.', {
          position: 'top-right',
          timeout: 3000
        })
      } finally {
        this.dataset.loading = false
        this.$router.push("/credores-procurador");
      }
    },

    buildPayload() {
      const formData = new FormData()

      formData.append('user_id', this.dataset.data.id)

      formData.append('name', this.dataset.data.name)
      formData.append('phone_number', this.dataset.data.phone_number)
      formData.append('nationality', this.dataset.data.nationality)
      formData.append('address_street', this.dataset.data.address_street)
      formData.append('address_number', this.dataset.data.address_number)
      formData.append('address_complement', this.dataset.data.address_complement)
      formData.append('address_neighborhood', this.dataset.data.address_neighborhood)
      formData.append('address_city', this.dataset.data.address_city)
      formData.append('address_postal_code', (this.dataset.data.address_postal_code || '').replace(/\D/g, ''));
      formData.append('address_state', this.dataset.data.address_state)

      if (this.dataset.data.file) {
        formData.append('file', this.dataset.data.file)
      }

      // ================= OUTROS DOCUMENTOS (NOVOS) =================
      if (Array.isArray(this.dataset.data.company_other_files)) {
        this.dataset.data.company_other_files.forEach((file) => {
          if (file instanceof File) {
            formData.append('other_files[]', file)
          }
        })
      }

      // ================= OUTROS DOCUMENTOS (REMOVIDOS) =================
      if (Array.isArray(this.dataset.data.deleted_other_documents)) {
        this.dataset.data.deleted_other_documents.forEach(id => {
          formData.append('deleted_other_documents[]', id)
        })
      }

      return formData
    },

    addOtherFile(index) {
      this.dataset.data.company_other_files.push(null)
    },

    removeOtherFile(index) {
      this.dataset.data.company_other_files.splice(index, 1)
    },

    async loadCreditorData(userId) {

      this.loading = true;
      try {
        const response = await axios.get('/api/lawyers/associated-user', {
          params: { userId }
        });

        const creditorData = response.data;

        if (creditorData && creditorData.content) {

          this.dataset.data = { ...creditorData.content}


          this.otherDocuments = Array.isArray(creditorData.content.otherDocuments)
            ? creditorData.content.otherDocuments.map(doc => ({
                ...doc,
                _isNew: false
              }))
            : [];

          const registration = this.dataset.data.registration || '';

          this.isRegistrationCNPJ = registration.replace(/\D/g, '').length > 11;

        } else {
          this.$dialog.notify.error("Erro ao carregar os detalhes do credor.", { position: "top-right", timeout: 3000 });
        }
      } catch (error) {

        const hasResponse = error && error.response && error.response.data;

        if (hasResponse) {

          const apiMessage =
            error.response &&
            error.response.data &&
            error.response.data.content &&
            error.response.data.content.error &&
            error.response.data.content.error.message;

          this.$dialog.notify.error(
            apiMessage || "Erro ao carregar dados do credor!",
            {
              position: "top-right",
              timeout: 5000,
            }
          );
        }
      } finally {
        this.loading = false;
      }
    },

    async fetchCep(cep, target) {
      const cleanCep = cep.replace(/\D/g, '')
      if (cleanCep.length !== 8) return

      try {
        const response = await axios.get(`https://viacep.com.br/ws/${cleanCep}/json/`)
        const data = response.data

        if (!data.erro) {
          target.address_street = data.logradouro
          target.address_neighborhood = data.bairro
          target.address_city = data.localidade
          target.address_state = data.uf
        } else {
          target.address_street = ''
          target.address_neighborhood = ''
          target.address_city = ''
          target.address_state = null
        }

      } catch (error) {
        target.address_street = ''
        target.address_neighborhood = ''
        target.address_city = ''
        target.address_state = null
      }
    },
  },

};
</script>
<style lang="scss">
.title-page {
  color: var(--v-primary-base);
  font-family: Montserrat;
  font-size: 40px;
  font-style: normal;
  font-weight: 700;
  line-height: 38px;
}

p {
  text-align: justify;
}
</style>